import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { ITranslatorRequest } from '@models/keyword/keywordModel';

// Translator 데이터 요청
export const fetchTranslatorData = createAsyncThunk('fetchTranslatorData', async (params: ITranslatorRequest) => {
  // const { data, status } = await axiosDummyInstance.get('/api/keyword/translatorData.json', { params });
  const { data, status } = await axiosScraper.post('/axo/translate', params);
  if (status === 200) {
    return data;
  }
});
